<template>
  <div>
    <div class="my-auto">
      <div class="d-flex my-auto">
        <b-avatar
          badge
          :badge-variant="
            userAgentData.onlineStatus == 1 ? 'success' : 'danger'
          "
          :src="userAgentData.displayPicture"
        ></b-avatar>
        <div class="ml-2">
          <h4 class="m-0 p-0">{{ userAgentData.userName }}</h4>
          <p class="text-muted m-0 p-0">{{ userAgentData.role }}</p>
          <!-- <p class="m-0 p-0">
            {{ userAgentData.email || userAgentData.userName + "@on-track.in" }}
          </p> -->
        </div>
      </div>
      <b-row cols-md="12" class="my-4">
        <b-col md="6">
          <p>
            <i class="fal fa-birthday-cake"></i>
            {{ userAgentData.dob || 'NA' | moment("ll") }}
          </p>
        </b-col>
        <b-col md="6">
          <p>
            <i class="fal fa-building"></i>
            {{ userAgentData.doj || 'NA' | moment("ll") }}
          </p>
        </b-col>
        <b-col md="6">
          <p><i class="fal fa-envelope"></i> {{ userAgentData.email || 'NA'}}</p>
        </b-col>
        <b-col md="6">
          <p><i class="fal fa-phone"></i> {{ userAgentData.mobile || 'NA' }}</p>
        </b-col>
      </b-row>
    </div>
    <div class="my-4">
      <p class="text-muted">
        Last seen on {{ userAgentData.updatedAt | moment("lll") }}
      </p>
      <b-button pill variant="success" :href="'mailto:' + userAgentData.email">
        <i class="far fa-paper-plane"></i> Send Email
      </b-button>
      <b-button
        pill
        variant="outline-primary"
        class="ml-2"
        :href="'tel:' + userAgentData.mobile"
      >
        <i class="fal fa-phone-alt"></i>
        Call</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    userAgentData: Object,
  },
  methods: {},
  watch: {},
  computed: {},
};
</script>

<style></style>
